export default {"src":"/_next/static/media/etn.dbfa2953.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};